@if (dialogs.findings()) {
  <app-modal
    [title]="'features.plan.edit.dialogs.findings.save_title' | translate"
    [config]="findingsConfig()"
    [size]="ModalSize.MD"
    (closeModal)="dialogs.findings.set(null)">
    <div modal-body class="flex flex-col gap-3">
      <p class="text-text-secondary text-sm">
        {{ 'features.plan.edit.dialogs.findings.save_message' | translate }}
      </p>
      <app-plan-findings-panel
        [findings]="findings()"
        [entityTypeLabels]="entityTypeLabels()"
        [live]="true" />
    </div>
  </app-modal>
}

@if (dialogs.discard()) {
  <app-modal
    [title]="
      countKey('discard.title', unsavedCount()) | translate: { count: unsavedCount() }
    "
    [config]="discardConfig()"
    (closeModal)="dialogs.discard.set(false)">
    <p modal-body class="text-text-secondary text-sm">
      {{ 'features.plan.edit.dialogs.discard.message' | translate }}
    </p>
  </app-modal>
}

@if (leavePrompt.open()) {
  <app-modal
    [title]="'features.plan.edit.dialogs.leave.title' | translate"
    [config]="leaveConfig()"
    (closeModal)="leavePrompt.answer('stay')">
    <div modal-body class="flex flex-col gap-2 text-sm">
      <p class="text-text-secondary">
        {{
          countKey('leave.message', unsavedCount()) | translate: { count: unsavedCount() }
        }}
      </p>
      @if (mode() === 'disconnected') {
        <p class="text-warning-hover">
          {{ 'features.plan.edit.dialogs.leave.disconnected' | translate }}
        </p>
      }
    </div>
  </app-modal>
}
